// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6B05N","col":"styles_col__UGh5v"};